export default __webpack_public_path__ + "static/media/crest.9e89089a.png";